import { Table } from "@/features/Table";
import { useBulkDeleteControls } from "@/features/Edit/useBulkDeleteControls";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { type L1TimeSerie, columns } from "./columns";
import { type FilterL1TimeSeriesSchema, FilterL1TimeSeries } from "./filter";

const client = Clients.L1;
const table_name = Tables.L1_TIME_SERIES;

export const L1TimeSeriesTable = () => {
  const { selectionActions, modal } = useBulkDeleteControls<L1TimeSerie>({
    client,
    table_name,
    resourceLabel: "Valorisation",
  });

  return (
    <>
      <Table<L1TimeSerie, FilterL1TimeSeriesSchema>
        label="Valorisation"
        client={client}
        table_name={table_name}
        columns={columns}
        filter={<FilterL1TimeSeries />}
        actions={[
          {
            label: "actions.new",
            route: `${client}/${table_name}/new`,
          },
        ]}
        enableRowSelection
        selectionActions={selectionActions}
      />
      {modal}
    </>
  );
};
